/* eslint-disable @typescript-eslint/naming-convention */
export enum PeriodType {
  SIX_MONTHS = 'SIX_MONTHS',
  ONE_MONTH = 'ONE_MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
  CUSTOM = 'CUSTOM'
}

